import React from "react";
import { Typography } from "@tvg/fuse/typography";
import { Brand } from "../../../../types/brand";

import styles from "../common.module.css";
import { getCopyrightText } from "../../../utils/constants";

export interface AppProps {
  brand: string | undefined;
}

const CopyrightSection: React.FC<AppProps> = ({ brand }) => {
  const copyrightText = getCopyrightText(brand);
  const isVeryIreland = brand === Brand.VeryIE;

  return (
    <div
      className={`${styles.footerCopyrightContainer} footer__copyright-section`}
      data-testid="copyright-section"
    >
      {isVeryIreland ? (
        <>
          {copyrightText.registeredDetails.map((detail, index) => (
            <Typography
              key={index}
              type="paragraph"
              size="m2"
              className={styles.simple_footer__registered_details}
              tag="p"
            >
              {detail}
            </Typography>
          ))}
          <Typography
            type="paragraph"
            size="m2"
            className={styles.simple_footer__copyright}
            tag="p"
          >
            {copyrightText.copyright}
          </Typography>
        </>
      ) : (
        <>
          <Typography
            type="paragraph"
            size="m2"
            className={styles.simple_footer__copyright}
            tag="p"
          >
            {copyrightText.copyright}
          </Typography>

          {copyrightText.registeredDetails.map((detail, index) => (
            <Typography
              key={index}
              type="paragraph"
              size="m2"
              className={styles.simple_footer__registered_details}
              tag="p"
            >
              {detail}
            </Typography>
          ))}
        </>
      )}
    </div>
  );
};

export default CopyrightSection;
